var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'enterprise-live-map' }}},[_c('div',{staticClass:"cursor-pointer",attrs:{"id":"to-live-map-button"}},[_c('div',{staticClass:"menu-icon-button"},[_c('span',{staticClass:"menu-icon"}),_c('span',{staticClass:"aisea-text-12-400-pure-white"},[_vm._v("LiveMapに戻る")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }